import React, { useEffect, useState } from "react";
import { useQuery } from "react-apollo";
import _ from "lodash";
import { Button, Form } from "react-bootstrap";
import { GET_SOIL_INTERPRETATIONS } from "../../../../../queries";
import { GetSoilInterpretations } from "../../../../../__generated__/types";

import { getInterpsByAoi } from "../../../utils/ssrugoSoils";
import { Field } from "../../../types/types";

// local row type
type GetSoilInterpretations_landscan_soilinterpretations =
  GetSoilInterpretations['landscan_soilinterpretations'][number];
interface SoilFormProps {
    onSubmit: (keyId: number, interp: string) => void,
    field: Field
}

const SoilInterpretationsForm = ({onSubmit, field}: SoilFormProps ) => {
    const [AOIData, setAOIData] = useState<any>(null);
    const [AOIInterpretations, setAOIInterpretations] = useState<GetSoilInterpretations_landscan_soilinterpretations[]>([]);
    const [interpretations, setInterpretations] = useState<GetSoilInterpretations_landscan_soilinterpretations[]>([]);
    const [AOICategories, setAOICategories] = useState<string[]>([]);
    const [AOICategorySelected, setAOICategorySelected] = useState<string | null>(null);
    const [categories, setCategories] = useState<string[]>([]);
    const [excludeCategories, setExcludeCategories] = useState<string[]>([ // Categories to exclude from NRCS selector
        "Building Site Development", 
        "Construction Materials",
        "Disaster Recovery Planning",
        "Military Operations",
        "Recreational Development",
        "Sanitary Facilities",
        "Waste Management",
        "Wildlife Management"
    ]);
    const [excludeInterpretations, setExcludeInterpretations] = useState<string[]>([  // Interpretations to exclude from NRCS selector
        "...", 
        "..."
    ]);
    const [allData, setAllData] = useState<GetSoilInterpretations_landscan_soilinterpretations[]>([]);
    const [selectedInterpKey, setSelectedInterpKey] = useState<number | null>(null);
    const [selectedAOIInterpKey, setSelectedAOIInterpKey] = useState<number | null>(null);
    const [isLoading, setLoading] = useState(false);

    //const {data, loading} = useQuery<GetSoilInterpretations>(GET_SOIL_INTERPRETATIONS);

    /*useEffect(() => {
      if(data) {
        //const groups = _.groupBy(data.landscan_soilinterpretations, (item) => item.interpretation_group);
        //const cats = Object.keys(groups).sort();

        //setAllData(data.landscan_soilinterpretations);
        //setCategories(cats);

        //const interps = data.landscan_soilinterpretations.filter((s: GetSoilInterpretations_landscan_soilinterpretations) => s.interpretation_group === cats[0]);
        //setInterpretations(interps);
        //const ext_id = interps.filter((s:any) => s.name === "Soil Taxonomy Classification")[0].external_id;
        //setSelectedInterpKey(ext_id);
        //getAOIData(field.geom)
      }
    }, [data, field]);*/

    useEffect(() => {
        getAOIData(field.geom)
    }, [field]);

    useEffect(() => {
        //console.log("interpretations", interpretations)
        if (AOIData /*&& interpretations*/){
            //console.log("AOIData", AOIData)
            let fCategories = AOIData.tables[1].folders.filter((s:any) => {
                //if (categories.includes(s.foldername)){ // Filter against Hasura table (category) values
                //    return s;
                //}
                if (!excludeCategories.includes(s.foldername)){ // Filter against hardcoded categories to exclude
                    return s;
                }
            }).map((r:any) => r.foldername);
            setAOICategories(fCategories);
            //setCategory(fCategories[0]);
            //console.log("fCategories", fCategories)
            const selectedCat = fCategories.filter((s:any) => {
                //console.log("s", s)
                if (s === "Land Classifications"){
                    return s;
                }
            });
            //console.log("selectedCat", selectedCat)
            setAOICategorySelected(selectedCat.length ? selectedCat[0] : fCategories[0])
            setAOICategory(selectedCat.length ? selectedCat[0] : fCategories[0]/*, interpretations*/);
        }
        
    }, [AOIData]);

    const getAOIData = async (geom:any) => {
        setAOIData(await getInterpsByAoi(geom));
    }
    
    const setAOICategory = (category:string/*, _interpretations:any*/) => {
        const interpsRaw = AOIData.tables[1].folders.filter((s: any) => s.foldername === category)[0].attributes;
        //const interpretationsArray = _interpretations.map((q:any) => q.name); 
        const interps = interpsRaw.filter((v:any) => {
            //if (interpretationsArray.includes(v.attributename)){  // Filter against Hasura table (category) values
            //    return v;
            //}
            if (!excludeInterpretations.includes(v.attributename)){  // Filter against hardcoded interps to exclude
                return v;
            }
        }).map((x:any) => {
            return {
                external_id: parseInt(x.attributekey),
                interpretation_group: category,
                interpretation_id:"",
                name: x.attributename,
            }
        })
        //console.log("interps",interps);
        setAOIInterpretations(interps);
        const selectedInterp = interps.filter((s: any) => s.name === "Soil Taxonomy Classification");
        //console.log("selectedInterp", selectedInterp);
        setSelectedAOIInterpKey(selectedInterp.length ? selectedInterp[0].external_id : interps[0].external_id);
    }

    /*const setCategory = (category:string) => {
        const interps = allData.filter((s: GetSoilInterpretations_landscan_soilinterpretations) => s.interpretation_group === category);
        setInterpretations(interps);
        console.log("category", category)
        console.log("allData", allData)
        console.log("interps", interps)
        setSelectedInterpKey(interps[0].external_id);
        setAOICategory(category)
    }*/

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        if(selectedAOIInterpKey) {
            const selected = AOIInterpretations.find((i:GetSoilInterpretations_landscan_soilinterpretations) => selectedAOIInterpKey === i.external_id);
            if(selected) {
                setLoading(true);
                await onSubmit(selected.external_id!, selected.name!);
                setLoading(false);
            }
        }
    }
    
    return (
        <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
                <Form.Label>Category</Form.Label>
                <Form.Control 
                    as="select"
                    size="sm"
                    value={AOICategorySelected ? AOICategorySelected : undefined}
                    onChange={(e:any) => {
                            setAOICategory(e.currentTarget.value);
                            setAOICategorySelected(e.currentTarget.value);
                        }
                    }
                >
                    {AOICategories.map(c => {
                        return <option key={c} value={c}>{c}</option>
                    })}
                </Form.Control>
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label>Interpretation</Form.Label>
                <Form.Control 
                    as="select"
                    size="sm"
                    value={selectedAOIInterpKey ? selectedAOIInterpKey.toString() : undefined}
                    onChange={(e:any) => setSelectedAOIInterpKey(e.currentTarget.value)}
                >
                    {AOIInterpretations.map(i => {
                        return <option key={i.external_id!} value={i.external_id!}>{i.name}</option>
                    })}
                </Form.Control>
            </Form.Group>
                
            <Button 
                variant="secondary" 
                size="sm" 
                type="submit"
                disabled={isLoading}
            >
             {isLoading ? 'Loading…' : 'Load'}
            </Button>  
        </Form>
    )
}

export default SoilInterpretationsForm;